import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ProductDetailsData } from "../../../products/product.types";
import { requestGetProductById } from "./getProductById.request";

const useGetProductById = (
  productId: string,
  options?: QueryOptions<ProductDetailsData, ApiServiceError<ApiError>>
) => {
  const { data: product, ...rest } = useQuery({
    queryKey: ["products", "admin", "one", productId],
    queryFn: async () => {
      return await requestGetProductById(productId);
    },
    enabled: !!productId,
    cacheTime: 0,
    ...options
  });

  return { product, ...rest };
};

export default useGetProductById;
